import React from "react";
import Video from "./Video";
import { HomeConfig } from "config/homeConfig";
import { ContentInfoWrapper } from "./styled";

export default function ContentInfo() {
  return (
    <ContentInfoWrapper>
      <div className="contentInfo-wrapper">
        {/* <img src={HomeConfig.contentInfo.poster} alt="content img" /> */}
        <Video
          video={HomeConfig.contentInfo.video}
          poster={HomeConfig.contentInfo.poster}
        />
      </div>
      <div className="contentInfo_content">
        <div className="title">{HomeConfig.contentInfo.title}</div>
        <div className="line" />
        <div className="subtitle">{HomeConfig.contentInfo.subtitle}</div>
        <div className="more">{HomeConfig.contentInfo.content}</div>
      </div>
    </ContentInfoWrapper>
  );
}
